import { useQuery } from '@tanstack/react-query';
import {
	getAboutPage,
	getBlogPosts,
	getBlogPostBySlug,
	getContactPage,
	getPrivacyPage,
	getTermsPage,
	getWorkshopBySlug,
	getWorkshops,
	getTestimonials,
	getPartners,
	getStats,
	getServicesPage,
	getFaq,
	getSiteSettings,
} from '@/sanity/client';

// About page data
export const useAboutPage = () => {
	return useQuery({
		queryKey: ['aboutPage'],
		queryFn: getAboutPage,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Blog posts
export const useBlogPosts = () => {
	return useQuery({
		queryKey: ['blogPosts'],
		queryFn: getBlogPosts,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Single blog post
export const useBlogPost = (slug: string) => {
	return useQuery({
		queryKey: ['blogPost', slug],
		queryFn: () => getBlogPostBySlug(slug),
		staleTime: 1000 * 60 * 5, // 5 minutes
		enabled: !!slug,
	});
};

// Contact page data
export const useContactPage = () => {
	return useQuery({
		queryKey: ['contactPage'],
		queryFn: getContactPage,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Privacy page data
export const usePrivacyPage = () => {
	return useQuery({
		queryKey: ['privacyPage'],
		queryFn: getPrivacyPage,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Terms page data
export const useTermsPage = () => {
	return useQuery({
		queryKey: ['termsPage'],
		queryFn: getTermsPage,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Workshop data
export const useWorkshop = (slug: string) => {
	return useQuery({
		queryKey: ['workshop', slug],
		queryFn: () => getWorkshopBySlug(slug),
		staleTime: 1000 * 60 * 5, // 5 minutes
		enabled: !!slug,
	});
};

// All workshops
export const useWorkshops = () => {
	return useQuery({
		queryKey: ['workshops'],
		queryFn: getWorkshops,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Testimonials data
export const useTestimonials = () => {
	return useQuery({
		queryKey: ['testimonials'],
		queryFn: getTestimonials,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Partners data
export const usePartners = () => {
	return useQuery({
		queryKey: ['partners'],
		queryFn: getPartners,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Stats data
export const useStats = () => {
	return useQuery({
		queryKey: ['stats'],
		queryFn: getStats,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Services page data
export const useServicesPage = () => {
	return useQuery({
		queryKey: ['servicesPage'],
		queryFn: getServicesPage,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// FAQ data
export const useFaq = () => {
	return useQuery({
		queryKey: ['faq'],
		queryFn: getFaq,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};

// Site Settings
export const useSiteSettings = () => {
	return useQuery({
		queryKey: ['siteSettings'],
		queryFn: getSiteSettings,
		staleTime: 1000 * 60 * 60, // 1 hour
	});
};
